module.exports = __webpack_public_path__ + "img/icons_4.6eaad2f7.png";